<template>
  <basic-container>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="0"
             class="demo-ruleForm">
      <div class="details_border">
        <div class="details_title_center">
          项目个案档案
        </div>
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">个案信息</div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">个案档案编号：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value1"
                            style="width: 100%">
                <el-input v-model="ruleForm.value1"
                          placeholder="系统自动生成"
                          readonly
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value1}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">项目类型：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value2"
                            style="width: 100%">
                <el-select v-model="ruleForm.value2"
                           placeholder="请选择 项目类型"
                           class='details_flex1_right_input'>
                  <el-option v-for="item in options1"
                             :key="item.value"
                             :label="item.dictValue"
                             :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-else>{{ruleForm.value2}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">经办人：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value3"
                            style="width: 100%">
                <el-input v-model="ruleForm.value3"
                          placeholder="请输入经办人"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value3}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">服务机构：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value4"
                            style="width: 100%">
                <el-select v-model="ruleForm.value4"
                           placeholder="请选择 服务机构"
                           disabled
                           class='details_flex1_right_input'>
                  <el-option v-for="item in options7"
                             :key="item.value"
                             :label="item.title"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-else>{{ruleForm.value4}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">类型：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value5"
                            style="width: 100%">
                <el-select v-model="ruleForm.value5"
                           placeholder="请选择类型"
                           class='details_flex1_right_input'>
                  <el-option v-for="item in options2"
                             :key="item.value"
                             :label="item.dictValue"
                             :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-else>{{ruleForm.value5}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">服务状态：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value6"
                            style="width: 100%">
                <el-select v-model="ruleForm.value6"
                           placeholder="请选择服务状态"
                           class='details_flex1_right_input'>
                  <el-option v-for="item in options3"
                             :key="item.value"
                             :label="item.dictValue"
                             :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-else>{{ruleForm.value6}}</div>
            </div>
          </div>
        </div>
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">基本信息</div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">姓名：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value7"
                            style="width: 100%">
                <el-input v-model="ruleForm.value7"
                          placeholder="请输入姓名"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value7}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">性别：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value8"
                            style="width: 100%">
                <el-radio v-model="ruleForm.value8"
                          label="1">男</el-radio>
                <el-radio v-model="ruleForm.value8"
                          label="2">女</el-radio>
              </el-form-item>
              <div v-else>{{ruleForm.value8}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">身份证号：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value9"
                            style="width: 100%">
                <el-input v-model="ruleForm.value9"
                          placeholder="请输入身份证号"
                          class='details_flex1_right_input'
                          @blur="idCard"></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value9}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">出生年月：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value10"
                            style="width: 100%">
                <el-date-picker class='details_flex1_right_input'
                                v-model="ruleForm.value10"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <div v-else>{{ruleForm.value10}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">年龄：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value11"
                            style="width: 100%">
                <el-input v-model="ruleForm.value11"
                          placeholder="请输入年龄"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value11}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">现在所在区域：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value12"
                            style="width: 100%">
                <el-cascader size="large"
                             class='details_flex1_right_input'
                             :props="props"
                             v-model="ruleForm.value12"
                             @change="handleChange">
                </el-cascader>
              </el-form-item>
              <div v-else>{{ruleForm.value12}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">户籍所在地：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value13"
                            style="width: 100%">
                <el-input v-model="ruleForm.value13"
                          placeholder="请输入户籍所在地"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value13}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">现住详细地址：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value133"
                            style="width: 100%">
                <el-input v-model="ruleForm.value133"
                          placeholder="请输入现住详细地址"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value133}}</div>
            </div>
          </div>
        </div>
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">家庭情况</div>
        </div>
        <div class="details_line details_line_crud">
          <avue-crud :option="familyOption"
                     :search.sync="search"
                     :table-loading="loading"
                     :data="data"
                     ref="crud"
                     @row-del="rowDel"
                     v-model="form"
                     :page.sync="page"
                     :permission="permissionList"
                     @search-change="searchChange"
                     @search-reset="searchReset"
                     @selection-change="selectionChange"
                     @current-change="currentChange"
                     @size-change="sizeChange"
                     @refresh-change="refreshChange"
                     @on-load="onLoad"
                     @error="error">
          </avue-crud>
        </div>
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">健康状况|照料情况</div>
        </div>
        <div class="details_line details_line_crud">
          <avue-crud :option="healthyOption"
                     :search.sync="search"
                     :table-loading="loading"
                     :data="data"
                     ref="crud"
                     @row-del="rowDel"
                     v-model="form"
                     :page.sync="page"
                     :permission="permissionList"
                     @search-change="searchChange"
                     @search-reset="searchReset"
                     @selection-change="selectionChange"
                     @current-change="currentChange"
                     @size-change="sizeChange"
                     @refresh-change="refreshChange"
                     @on-load="onLoad"
                     @error="error">
          </avue-crud>
        </div>
        <!-- <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">身体情况：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value14"
                            style="width: 100%">
                <el-select v-model="ruleForm.value14"
                           placeholder="请选择 身体情况"
                           class='details_flex1_right_input'>
                  <el-option v-for="item in options4"
                             :key="item.value"
                             :label="item.dictValue"
                             :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-else>{{ruleForm.value14}}</div>
            </div>
          </div>
        </div>
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">照料情况</div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">照料情况：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value15"
                            style="width: 100%">
                <el-radio v-model="ruleForm.value15"
                          :label="item.dictKey"
                          v-for="(item,index) in options6"
                          :key="index">{{item.dictValue}}</el-radio>
              </el-form-item>
              <div v-else>{{ruleForm.value15}}</div>
            </div>
          </div>
        </div>
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">存在的问题</div>
        </div>

        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">存在的问题描述：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value18"
                            style="width: 100%">
                <AvueUeditor v-model="ruleForm.value18"
                             :options="ueditorOptions"
                             style="width: 100%"></AvueUeditor>
              </el-form-item>
              <div v-else>{{ruleForm.value18}}</div>
            </div>
          </div>
        </div> -->
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">需求分析</div>
        </div>
        <div class="details_line details_line_crud">
          <avue-crud :option="demandOption"
                     :search.sync="search"
                     :table-loading="loading"
                     :data="data"
                     ref="crud"
                     @row-del="rowDel"
                     v-model="form"
                     :page.sync="page"
                     :permission="permissionList"
                     @search-change="searchChange"
                     @search-reset="searchReset"
                     @selection-change="selectionChange"
                     @current-change="currentChange"
                     @size-change="sizeChange"
                     @refresh-change="refreshChange"
                     @on-load="onLoad"
                     @error="error">
          </avue-crud>
        </div>
        <!-- <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">困境类型：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value17"
                            style="width: 100%">
                <el-select v-model="ruleForm.value17"
                           placeholder="请选择"
                           class='details_flex1_right_input'>
                  <el-option v-for="item in options5"
                             :key="item.value"
                             :label="item.dictValue"
                             :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-else>{{ruleForm.value17}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">需求分析说明：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value18"
                            style="width: 100%">
                <AvueUeditor v-model="ruleForm.value18"
                             :options="ueditorOptions"
                             style="width: 100%"></AvueUeditor>
              </el-form-item>
              <div v-else>{{ruleForm.value18}}</div>
            </div>
          </div>
        </div> -->
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">选择结对单位(温馨提示：如果没有对接机构，请忽略。)</div>
        </div>
        <div class="details_line details_line_crud">
          <avue-crud :option="informationOption"
                     :search.sync="search"
                     :table-loading="loading"
                     :data="data"
                     ref="crud"
                     @row-del="rowDel"
                     v-model="form"
                     :page.sync="page"
                     :permission="permissionList"
                     @search-change="searchChange"
                     @search-reset="searchReset"
                     @selection-change="selectionChange"
                     @current-change="currentChange"
                     @size-change="sizeChange"
                     @refresh-change="refreshChange"
                     @on-load="onLoad"
                     @error="error">
          </avue-crud>
        </div>
        <!-- <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">单位名称：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value2"
                            style="width: 100%">
                <el-select v-model="ruleForm.value2"
                           placeholder="请选择 单位名称"
                           class='details_flex1_right_input'>
                  <el-option v-for="item in options1"
                             :key="item.value"
                             :label="item.dictValue"
                             :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-else>{{ruleForm.value1}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">统一信用代码：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value1"
                            style="width: 100%">
                <el-input v-model="ruleForm.value1"
                          placeholder="请输入 统一信用代码"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value1}}</div>
            </div>
          </div>

        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">签约状态：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value2"
                            style="width: 100%">
                <el-select v-model="ruleForm.value2"
                           placeholder="请选择 单位名称"
                           class='details_flex1_right_input'>
                  <el-option v-for="item in options1"
                             :key="item.value"
                             :label="item.dictValue"
                             :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-else>{{ruleForm.value1}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">联系人：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value1"
                            style="width: 100%">
                <el-input v-model="ruleForm.value1"
                          placeholder="请输入 联系人"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value2}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">单位类型：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value1"
                            style="width: 100%">
                <el-input v-model="ruleForm.value1"
                          placeholder="请输入 单位类型"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value1}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">联系电话：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value1"
                            style="width: 100%">
                <el-input v-model="ruleForm.value1"
                          placeholder="请输入 联系电话"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value1}}</div>
            </div>
          </div>

        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">合同/协议编号：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value1"
                            style="width: 100%">
                <el-input v-model="ruleForm.value1"
                          placeholder="请输入 合同/协议编号"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value1}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">结对编号：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value1"
                            style="width: 100%">
                <el-input v-model="ruleForm.value1"
                          placeholder="请输入 结对编号"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value2}}</div>
            </div>
          </div>
          <div class="details_flex1">
            <div class="details_flex1_left">结对类型：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value1"
                            style="width: 100%">
                <el-input v-model="ruleForm.value1"
                          placeholder="请输入 结对类型"
                          class='details_flex1_right_input'></el-input>
              </el-form-item>
              <div v-else>{{ruleForm.value1}}</div>
            </div>
          </div>
        </div>
        <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">说明：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value18"
                            style="width: 100%">
                <AvueUeditor v-model="ruleForm.value18"
                             :options="ueditorOptions"
                             style="width: 100%"></AvueUeditor>
              </el-form-item>
              <div v-else>{{ruleForm.value18}}</div>
            </div>
          </div>
        </div> -->
        <!-- <div class="details_line">
          <div class="details_flex1">
            <div class="details_flex1_left">备注：</div>
            <div :class="['details_flex1_right', status == 2 ? 'details_flex1_right_padding' : ''  ]">
              <el-form-item label=""
                            v-if="status != 2"
                            prop="value18"
                            style="width: 100%">
                <AvueUeditor v-model="ruleForm.value18"
                             :options="ueditorOptions"
                             style="width: 100%"></AvueUeditor>
              </el-form-item>
              <div v-else>{{ruleForm.value18}}</div>
            </div>
          </div>
        </div> -->
        <div class="details_title">
          <i class="el-icon-s-order details_title_icon"></i>
          <div class="details_title_font">跟踪服务记录</div>
        </div>
        <div class="details_line details_line_crud">
          <avue-crud :option="trackOption"
                     :search.sync="search"
                     :table-loading="loading"
                     :data="data"
                     ref="crud"
                     @row-del="rowDel"
                     v-model="form"
                     :page.sync="page"
                     :permission="permissionList"
                     @search-change="searchChange"
                     @search-reset="searchReset"
                     @selection-change="selectionChange"
                     @current-change="currentChange"
                     @size-change="sizeChange"
                     @refresh-change="refreshChange"
                     @on-load="onLoad"
                     @error="error">
          </avue-crud>
        </div>
      </div>
    </el-form>
    <div>
      <el-button @click="resetForm">重置</el-button>
      <el-button type="primary"
                 @click="submit">保存</el-button>
    </div>
  </basic-container>
</template>
<script>
import { regionData } from "element-china-area-data";
import { mapGetters } from "vuex";
import { getAress } from '@/api/common/common'
import { dictionary, tree } from '@/api/project/project'
// import { getInfoFromIdCard } from '@/util/util'
// import { regionData, CodeToText } from "element-china-area-data";
export default {
  data () {
    return {
      value12Options: regionData,
      status: 1,// 1 新增/编辑 2 查看
      detailsState: false,
      dataObj: {},
      form: {},
      familyOption: {
        border: true,
        index: true,
        calcHeight: 100,
        labelWidth: '120',
        column: [
          {
            label: "姓名",
            prop: "tenantId",
            span: 12,
            rules: [{
              required: true,
              message: "请输入姓名",
              trigger: "blur"
            }]
          },
          {
            label: "身份证号",
            prop: "tenantId",
            span: 12,
            rules: [{
              required: true,
              message: "请输入身份证号",
              trigger: "blur"
            }]
          },
          {
            label: "年龄",
            prop: "tenantId",
            span: 12,
          },
          {
            label: "文化程度",
            prop: "tenantId1",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=Academic_stage",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: "收入",
            prop: "tenantId",
            span: 12,
            required: true,
          },
          {
            label: "收入来源",
            prop: "tenantId2",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=source_expenses",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请选择收入来源",
              trigger: "blur"
            }]
          },
          {
            label: "职业",
            prop: "tenantId",
            span: 12,
          },
          {
            label: "关系",
            prop: "tenantId",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=relationship",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请输入关系",
              trigger: "blur"
            }]
          },
          {
            label: "联系方式",
            prop: "tenantId",
            span: 12,
            rules: [{
              required: true,
              message: "请输入联系方式",
              trigger: "blur"
            }]
          },
          {
            label: "现状",
            prop: "tenantId",
            span: 24,
            type: 'textarea',
            showWordLimit: true,
            maxlength: 500,
            rules: [{
              required: true,
              message: "请输入现状",
              trigger: "blur"
            }]
          },
        ]
      },
      trackOption: {
        border: true,
        index: true,
        calcHeight: 100,
        labelWidth: '120',
        column: [
          {
            label: "单据号",
            prop: "tenantId",
            placeholder: '系统自动生成',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "系统生成单据号",
              trigger: "blur"
            }]
          },
          {
            label: "跟踪服务类型",
            prop: "tenantId123123",
            type: 'select',
            span: 12,
            rules: [{
              required: true,
              message: "请选择跟踪服务类型",
              trigger: "blur"
            }],
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=service_type",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            dataType: "number",
          },
          {
            label: "日期/时间",
            prop: "datetime",
            type: "datetime",
            span: 12,
            format: 'yyyy-MM-dd HH:mm:00',
            valueFormat: 'yyyy-MM-dd HH:mm:00',
            rules: [{
              required: true,
              message: "请选择日期/时间",
              trigger: "blur"
            }]
          },
          {
            label: "跟踪经办人",
            prop: "tenantId",
            span: 12,
            rules: [{
              required: true,
              message: "请输入跟踪经办人",
              trigger: "blur"
            }]
          },
          {
            label: "服务机构",
            prop: "tenantId22",
            span: 24,
            type: 'select',
            disabled: this.$store.state.user.userInfo.account === 'admin' ? false : true,
            dicUrl: "/api/blade-system/dept/tree",
            props: {
              label: 'title',
              value: "value"
            },
            value: this.$store.state.user.userInfo.dept_id,
            dataType: 'string',
            rules: [{
              required: true,
              message: "请输入服务机构",
              trigger: "blur"
            }]
          },
          {
            label: "情况描述",
            prop: "tenantId",
            span: 24,
            component: 'AvueUeditor',
            options: {
              action: '/api/blade-resource/oss/endpoint/put-file',
              props: {
                res: "data",
                url: "link",
              }
            },
            rules: [{
              required: true,
              message: "请输入情况描述",
              trigger: "blur"
            }]
          },
        ]
      },
      demandOption: {
        border: true,
        index: true,
        calcHeight: 100,
        labelWidth: '120',
        column: [
      {
            label: "日期/时间",
            prop: "datetime",
            type: "datetime",
            span: 12,
            format: 'yyyy-MM-dd HH:mm:00',
            valueFormat: 'yyyy-MM-dd HH:mm:00',
            rules: [{
              required: true,
              message: "请选择日期/时间",
              trigger: "blur"
            }]
          },
          {
            label: "记录人",
            prop: "tenantId",
            placeholder: '请输入 记录人',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "请输入 记录人",
              trigger: "blur"
            }]
          },
          {
            label: "困境类型",
            prop: "tenantId5",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=dilemma_types",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请选择困境类型",
              trigger: "blur"
            }]
          },
          {
            label: "需求分析说明",
            prop: "tenantId",
            placeholder: '请输入 需求分析',
            component: 'AvueUeditor',
            span: 24,
            hide: true,
            readonly: true,
            rules: [{
              required: true,
              message: "请输入 需求分析",
              trigger: "blur"
            }]
          },

        ]
      },
      healthyOption: {
        border: true,
        index: true,
        calcHeight: 100,
        labelWidth: '120',
        column: [
          {
            label: "日期/时间",
            prop: "datetime",
            type: "datetime",
            span: 12,
            format: 'yyyy-MM-dd HH:mm:00',
            valueFormat: 'yyyy-MM-dd HH:mm:00',
            rules: [{
              required: true,
              message: "请选择日期/时间",
              trigger: "blur"
            }]
          },
          {
            label: "记录人",
            prop: "tenantId",
            placeholder: '请输入 记录人',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "请输入 记录人",
              trigger: "blur"
            }]
          },
          {
            label: "身体情况",
            prop: "tenantId3",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=physical_condition",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请选择身体情况",
              trigger: "blur"
            }]
          },
          {
            label: "照料情况",
            prop: "tenantId4",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=care_situation",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请选择照料情况",
              trigger: "blur"
            }]
          },
          {
            label: "存在的问题",
            prop: "tenantId",
            placeholder: '请输入 存在的问题',
            component: 'AvueUeditor',
            span: 24,
            hide: true,
            readonly: true,
            rules: [{
              required: true,
              message: "请输入存在的问题",
              trigger: "blur"
            }]
          },

        ]
      },
      informationOption: {
        border: true,
        index: true,
        calcHeight: 100,
        labelWidth: '120',
        column: [
          {
            label: "日期/时间",
            prop: "datetime",
            type: "datetime",
            span: 12,
            format: 'yyyy-MM-dd HH:mm:00',
            valueFormat: 'yyyy-MM-dd HH:mm:00',
            rules: [{
              required: true,
              message: "请选择日期/时间",
              trigger: "blur"
            }]
          },
          {
            label: "记录人",
            prop: "tenantId",
            placeholder: '请输入 记录人',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "请输入 记录人",
              trigger: "blur"
            }]
          },
          {
            label: "单位名称",
            prop: "tenantId",
            placeholder: '请选择 选择单位',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "请选择 选择单位",
              trigger: "blur"
            }]
          },
          {
            label: "统一信用代码",
            prop: "tenantId",
            placeholder: '请选择 统一信用代码',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "请选择 统一信用代码",
              trigger: "blur"
            }]
          },
          {
            label: "签约状态",
            prop: "tenantId8",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=signing_status",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请选择签约状态",
              trigger: "blur"
            }]
          },
          {
            label: "联系人",
            prop: "tenantId",
            placeholder: '请输入 联系人',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "请输入 联系人",
              trigger: "blur"
            }]
          },
          {
            label: "单位类型",
            prop: "tenantId6",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=unit_types",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请选择单位类型",
              trigger: "blur"
            }]
          },
          {
            label: "联系电话",
            prop: "tenantId",
            placeholder: '请输入 联系电话',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "请输入 联系电话",
              trigger: "blur"
            }]
          },
          {
            label: "合同/协议编号",
            prop: "tenantId",
            placeholder: '请选择 合同/协议编号',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "请选择 合同/协议编号",
              trigger: "blur"
            }]
          },
          {
            label: "结对编号",
            prop: "tenantId",
            placeholder: '系统自动生成',
            span: 12,
            readonly: true,
            rules: [{
              required: true,
              message: "系统生成单据号",
              trigger: "blur"
            }]
          },
          {
            label: "结对类型",
            prop: "tenantId7",
            type: 'select',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=pair_type",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [{
              required: true,
              message: "请选择结对类型",
              trigger: "blur"
            }]
          },
          {
            label: "说明",
            prop: "tenantId",
            placeholder: '请填写 说明',
            component: 'AvueUeditor',
            span: 24,
            hide: true,
            readonly: true,
            rules: [{
              required: true,
              message: "请填写 说明",
              trigger: "blur"
            }]
          },
        ]
      },
      options1: [],
      options2: [],
      options3: [],
      options4: [],
      options5: [],
      options6: [],
      options7: [],
      value: '',
      ueditorOptions: {
        customConfig: {
          pasteFilterStyle: false,
          uploadVideoServer: '/api/blade-resource/oss/endpoint/put-file',
          uploadVideoName: 'file',
          uploadVideoHeaders: {
            'Blade-Auth': 'bearer ' + this.$store.state.user.token
          },
          uploadVideoProps: {
            res: 'data',
            url: 'downloadPath',
          },
          uploadVideoHooks: {
            success: function (xhr) {
              console.log('success', xhr)
            },
            customInsert: function (insertVideoFn, result) {
              // result 即服务端返回的接口
              // insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
              insertVideoFn(result.data.downloadPath)
            }
          }
        },
        action: '/api/blade-resource/oss/endpoint/put-file',
        oss: '',
        props: {
          res: 'data',
          url: 'downloadPath',
        },
        ali: {},
        qiniu: {}
      },
      ruleForm: {
        value1: '',
        value2: '',
        value3: '',
        value4: this.$store.state.user.userInfo.dept_id,
        value5: '',
        value6: '',
        value7: '',
        value8: '',
        value9: '',
        value10: '',
        value11: '',
        value12: [],
        value13: '',
        value133: '',
        value14: '',
        value15: '',
        value16: '',
        value17: '',
        value18: '',
      },
      rules: {
        value1: [
          { required: true, message: '系统按规则自动生成个案档案编号', trigger: 'blur' }
        ],
        value2: [
          { required: true, message: '请选择 项目类型', trigger: 'change' }
        ],
        value3: [
          { required: true, message: '请输入 经办人', trigger: 'blur' }
        ],
        value4: [
          { required: true, message: '请输入 服务机构', trigger: 'blur' }
        ],
        value5: [
          { required: true, message: '请选择 类型', trigger: 'change' }
        ],
        value6: [
          { required: true, message: '请选择 服务状态', trigger: 'change' }
        ],
        value7: [
          { required: true, message: '请输入 姓名', trigger: 'blur' }
        ],
        value8: [
          { required: true, message: '请选择 性别', trigger: 'change' }
        ],
        value9: [
          { required: true, message: '请输入 身份证号', trigger: 'blur' }
        ],
        value10: [
          { required: true, message: '请输入 出生年月', trigger: 'change' }
        ],
        value11: [
          { required: true, message: '请输入 年龄', trigger: 'blur' }
        ],
        value12: [
          { required: true, message: '请选择 现在所在区域', trigger: 'change' }
        ],
        value13: [
          { required: true, message: '请输入 户籍所在地', trigger: 'blur' }
        ],
        value133: [
          { required: true, message: '请输入 现住详细地址', trigger: 'blur' }
        ],
        value14: [
          { required: true, message: '请选择 身体情况', trigger: 'change' }
        ],
        value15: [
          { required: true, message: '请选择 照料情况', trigger: 'change' }
        ],
        value16: [
          { required: true, message: '请输入 需求分析存在的问题', trigger: 'blur' }
        ],
        value17: [
          { required: true, message: '请选择 困境类型', trigger: 'change' }
        ],
        value18: [
          { required: true, message: '请输入 备注', trigger: 'blur' }
        ],
      },
      props: {
        label: 'title',
        value: 'value',
        lazy: true,
        lazyLoad (node, resolve) {
          let list = [];
          let stop_level = 4;
          let level = node.level || 0;
          let callback = () => {
            resolve((list || []).map(ele => {
              return Object.assign(ele, {
                leaf: level >= stop_level
              })
            }));
          }
          const parentCode = (level === 0) ? "00" : node.data.id;
          getAress(parentCode).then(res => {
            list = res.data.data;
            callback()
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted () {
    this.tree();
    this.dictionary('project_type')
    this.dictionary('plan_type')
    this.dictionary('project_status')
    this.dictionary('physical_condition')
    this.dictionary('dilemma_types')
    this.dictionary('care_situation')
    this.status = this.$route.query.state
  },
  methods: {
    tree () {
      tree().then((res) => {
        console.log(res.data.data)
        this.options7 = res.data.data;
      })
    },
    idCard () {

    },
    dictionary (x) {
      dictionary(x).then((res) => {
        if (x === 'project_type') {
          this.options1 = res.data.data
        } else if (x === 'plan_type') {
          this.options2 = res.data.data
        } else if (x === 'project_status') {
          this.options3 = res.data.data
        } else if (x === 'physical_condition') {
          this.options4 = res.data.data
        } else if (x === 'dilemma_types') {
          this.options5 = res.data.data
        } else if (x === 'care_situation') {
          this.options6 = res.data.data
        }
      })
    },
    // 保存
    submit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          console.log(1)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm () {
      this.$refs['ruleForm'].resetFields();
    },
    handleChange () {
      console.log(this.ruleForm.value12)
      // var loc = "";
      // for (let i = 0; i < this.ruleForm.value12.length; i++) {
      //   loc += CodeToText[this.ruleForm.value12[i]];
      // }
      // alert(loc);
    }
  }
}
</script>
<style scoped>
.details_border {
  border: 1px solid #ebeef5;
  margin-bottom: 20px;
}
.details_title {
  border-bottom: 1px solid #ebeef5;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}
.details_title_center {
  border-bottom: 1px solid #ebeef5;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.details_line {
  border-bottom: 1px solid #ebeef5;
  /* padding: 0px 20px; */
  display: flex;
  align-items: flex-start;
  height: auto !important;
}
.details_flex1 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  /* align-items: center; */
  background-color: #fafafa;
}
.details_flex1_left {
  width: 300px;
  box-sizing: border-box;
  /* border-right: 1px solid #ebeef5; */
  color: #909399;
  padding: 10px 20px;
  text-align: center;
  float: left;
}
.details_flex1:last-child {
  border-left: 1px solid #ebeef5;
  height: 100%;
}
.details_flex1_right {
  /* min-height: 40px; */
  min-height: 62px;
  min-width: 200px;
  box-sizing: border-box;
  flex: 1;
  background-color: #fff;
  border-left: 1px solid #ebeef5;
  float: left;
  display: flex;
  align-items: center;
}
.details_flex1_right_padding {
  min-height: 40px;
  /* padding: 10px 0 10px 20px; */
}
.details_flex1_right_padding .el-form-item {
  margin-bottom: 0 !important;
}
.details_flex1_right_input {
  width: 100%;
}
.details_title_icon {
  font-size: 24px;
}
.details_title_font {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-left: 10px;
}
.title_font {
  font-size: 20px;
}
.details_line_crud {
  padding: 20px;
}
</style>